import {
  faTrashCan,
  faClockRotateLeft,
  faCodeMerge,
} from "@fortawesome/pro-solid-svg-icons";
import type { BatchAction } from "@components/CatalogIndex";

export type ClientTab = "active" | "archived";

export interface BatchActionHandlers {
  onDelete: () => void;
  onRestore: () => void;
  onMerge: () => void;
}

export const buildClientBatchActions = (
  tab: ClientTab,
  selectedCount: number,
  handlers: BatchActionHandlers
): BatchAction[] => {
  if (tab === "archived") {
    return [
      {
        icon: faClockRotateLeft,
        label: "Restore",
        onClick: handlers.onRestore,
      },
    ];
  }
  const actions: BatchAction[] = [
    {
      icon: faTrashCan,
      label: "Delete",
      onClick: handlers.onDelete,
      variant: "danger",
    },
  ];
  if (selectedCount >= 2) {
    actions.push({
      icon: faCodeMerge,
      label: "Merge",
      onClick: handlers.onMerge,
    });
  }
  return actions;
};
